import govmapConfig from 'config/govmap';

export class Govmap {
  getGeomapCoordinatesByAddress = (address) => {
    return new Promise((resolve) => {
      const {govmapScript} = this.addScripts();

      const {token, token_test, token_dev, ...govmapCreds} = govmapConfig;
      const govmapToken = process.env.NODE_ENV === 'production'
        ? window.location.hostname === 'devapp.accuraiser.com' ? token_test : token
        : token_dev;

      govmapScript.onload = () => {
        Promise.resolve()
          .then(() => window.govmap.createMap('map',
            {
              token: govmapToken,
              ...govmapCreds,
              layers: ['PARCEL_ALL'],
              showXY: true,
              identifyOnClick: true,
              isEmbeddedToggle: false,
              background: '-1',
              layersMode: 1,
              zoomButtons: true,
            }))
          .then(() => this.getCoordinates(address))
          .then((coords) => resolve(coords));
      };
    });
  };

  addScripts = () => {
    const jqueryScript = document.createElement('script');
    jqueryScript.src = 'https://code.jquery.com/jquery-3.3.1.min.js';
    jqueryScript.async = false;
    document.body.appendChild(jqueryScript);
    const govmapScript = document.createElement('script');
    govmapScript.src = 'https://www.govmap.gov.il/govmap/api/govmap.api.js';
    govmapScript.async = false;
    document.body.appendChild(govmapScript);

    return {govmapScript};
  };

  getCoordinates = async (address) => {
    const response = await window.govmap.geocode({keyword: address}, window.govmap.geocodeType.FullResult);
    if (response.data) {
      const {X: x, Y: y} = response.data[0];
      return {x, y};
    } else {
      return null;
    }
  };
}